import Image from "next/image";
import React from "react";
import { toCapitalize } from "@/utils";
import { CommunityOverview } from "@/models/community.model";
import { CommunityTab, handleCommunityTextColors } from "./utils";

interface Props {
  communities: CommunityOverview[];
  activeCommunity: CommunityOverview;
  setActiveCommunity: (tag: string) => void;
}

const CommunityOverview = (props: Props) => {
  const { communities, activeCommunity, setActiveCommunity } = props;

  return communities ? (
    <div className="ml-4 hidden h-fit gap-4 overflow-auto lg:grid lg:w-2/3 lg:grid-cols-2">
      <div className="rounded-md bg-card p-6">
        <p className="text-xl font-bold text-yellow-500">Not in the list? </p>
        <p className="mt-1">
          Contact us at{" "}
          <a
            href="mailto:leagueconnect@outlook.com"
            className="text-blue-400 underline"
          >
            leagueconnect@outlook.com
          </a>{" "}
          to be added!
        </p>
      </div>
      {communities.map((community, index) => (
        <div
          key={index}
          className={`flex cursor-pointer items-center justify-between rounded-md bg-card p-6 duration-75 ease-in hover:bg-card__light ${
            activeCommunity === community && `bg-card__light`
          }`}
          onClick={() => setActiveCommunity(community.tag)}
        >
          <div>
            <p className="w-56 overflow-hidden truncate text-xl font-medium text-gray-300 sm:w-64 lg:w-48 xl:w-64">
              {community.name}
            </p>
            <p
              className={`${handleCommunityTextColors(
                community.type as CommunityTab
              )} text-sm font-medium`}
            >
              {community.type && toCapitalize(community.type)}
            </p>
          </div>
          {community.thumbnail ? (
            <div className="ml-4 hidden items-center justify-center sm:flex">
              <Image src={community.thumbnail} height={64} width={64} alt="" />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  ) : null;
};

export default CommunityOverview;
